import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export function newRegistration(data) {
  const url = ApiUrl('noAuth/userRegistration');
  return Call('post', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function specialNeedsRegistration(data) {
  const url = ApiUrl('noAuth/specialNeedsRegistration');
  return Call('post', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function getOrganizations(data) {
  const url = ApiUrl('noAuth/list/invitationCodesAndOrgs');
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export async function getOrganizationCodes() {
  const url = ApiUrl('noAuth/list/invitationCodes');
  const res = await Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
  return res;
}
export async function getAccountEmailCheck(data) {
  const url = ApiUrl('noAuth/masterAccountEmailCheck');
  return Call('post', url, data, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);  
}

export function getMasterData(path=null) {
  let api_path = 'noAuth/getMasterData';
  if (path) {
    api_path += path
  }
  const url = ApiUrl(api_path);
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}

export function getAffiliatedOrganizations(orgId) {
  const url = ApiUrl(`noAuth/getAffiliatedOrg?orgId=${orgId}`);
  return Call('get', url, {}, ParseGeneralResponse, { responseDataKeys: { data: '' } }, true);
}